module.exports = __webpack_public_path__ + "img/introduction_img2.71d19b66.png";